import { Role } from "@/features/members/types";
import { GetRolesByScopeResponse } from "@/features/members/types/responses";
import http from "@/shared/lib/utils/http";

export async function getProjectRoles(): Promise<Role[]> {
  const params = new URLSearchParams();
  params.set("scope", "Project");

  const response = await http.get<GetRolesByScopeResponse>({
    url: `/roles?${params.toString()}`,
    contentType: "none",
  });

  return response.roles.map((dto) => ({
    id: dto.id,
    name: dto.name,
    description: dto.description,
  }));
}
